import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getFirstAllowedRoute,
  hasHistoryView,
  isHistoryPath,
} from '../helpers/employeePermissions';

/** Blocks call-history pages for SIP employees without history_view. */
export default function RequireHistoryView({ children }) {
  const employeeData = useSelector((state) => state.users.employeeData);
  const location = useLocation();

  if (!hasHistoryView(employeeData)) {
    if (isHistoryPath(location.pathname)) {
      return <Navigate to={getFirstAllowedRoute(employeeData)} replace />;
    }
  }

  return children;
}
